import App from 'view';
import { getAcceptedPickups } from 'operations/pickup/pickup-service';
import { handleOfferNotification } from 'operations/offer/offer-service';
import OfferNotification from 'view/pages/offer-notification';

export { getAcceptedPickups, handleOfferNotification, OfferNotification };

export default App;
